// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","323":"191c803f","513":"5ff9705d","706":"711ede07","726":"2b58ec26","991":"f6f37f6e"}[chunkId] + ".chunk.js";
};